export default "__VITE_ASSET__de73c8bb__"